import React, { useState, useEffect } from 'react'
import {
  Panel,
  Message,
  Form,
  CheckboxGroup,
  Checkbox,
  List,
  FlexboxGrid,
  RadioGroup,
  Radio,
} from 'rsuite'
import { Row, Col, ControlLabel, Button, Icon, Input } from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import { isValidators, requiredFiled } from '../../utils/ValidatorUtils'
import ButtonPanelWidget from '../ButtonPanelWidget'
import { isEmpty } from 'lodash'
import { getCheckUser } from '../../redux/actions/auth'
import { doneLoading, startLoading } from '../../utils/loading'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'
import { getUserByUsername, saveUserSetting } from '../../redux/actions/subProjectUserSetting'

export default function CreateUserSubProject(props) {
  const { isEdit, onComplete, editObj, onCancel } = props
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [searchError, setSearchError] = useState()
  const [vlidateError, setVlidateError] = useState()
  const [errorMsg, setErrorMsg] = useState()

  const { register, handleSubmit, errors, control, getValues, setValue, setError, clearErrors } =
    useForm()
  const [formSchema, setFormSchema] = useState()

  const [userName, setUsername] = useState(props.schema?.userName?.value)
  const [userInfo, setUserInfo] = useState()
  // const [mainProject, setMainProject] = useState(props.schema.mainProject.value)

  // const [role, setRole] = useState()

  useEffect(() => {
    // console.log('re-load editObj', JSON.stringify(props.schema))
    // setFormSchema()
    if (editObj) {
      setValue(props.schema.role.name, props.schema.role.value)
      setValue(props.schema.userStatus.name, props.schema.userStatus.value)
      setValue(props.schema.mainProject.name, props.schema.mainProject.value)
      // setMainProject(props.schema.mainProject.value)

      setUserInfo({
        email: editObj.userName,
        firstname: editObj.firstName,
        lastname: editObj.lastName,
        tel: editObj.contactNumber,
      })
    }

    setFormSchema(props.schema)
  }, [props])

  const handleOnSave = async (request) => {
    setIsLoading(false)
    startLoading()
    try {
      // console.log('handleOnSave request : ', request)
      const response = await saveUserSetting(request)

      onComplete()
    } catch (error) {
      setIsError(true)
      setErrorMsg('เกิดข้อผิดพลาดในการบันทึก กรุณาติต่อผู้ดูแลระบบ')
    }

    doneLoading()
    setIsLoading(true)
  }

  const onSearch = async (email) => {
    console.log('email', email)

    setUserInfo('')
    setSearchError('')

    let isHaveUser = false
    try {
      let response = await getUserByUsername(email)
      response.role.options = formSchema.role.options
      response.mainProject.options = formSchema.mainProject.options

      // setValue(response.role.name, response.role.value)
      // setValue(response.userStatus.name, response.userStatus.value)
      // setValue(response.mainProject.name, response.mainProject.value)

      setFormSchema(response)

      response?.userInfo &&
        setUserInfo({
          email: response.userInfo.userName,
          firstname: response.userInfo.firstName,
          lastname: response.userInfo.lastName,
          tel: response.userInfo.contactNumber,
        })

      isHaveUser = true
    } catch (e) {
      console.log('e', e)
    }

    if (!isHaveUser) {
      try {
        const response = await getCheckUser(email)

        if (response.isSuccess) {
          setUserInfo(response)
        } else {
          setSearchError(`ไม่พบผู้${formSchema.userName.label} : ${userName} ในระบบ`)
        }
      } catch (error) {
        setSearchError(`เกิดข้อผิดพลาดในการค้นหา กรุณาติต่อผู้ดูแลระบบ`)
      }
    }
  }

  const onSubmit = (data) => {
    console.log('data', data)
    const request = {
      userName: data.userInfo.email,
      firstName: data.userInfo.firstname,
      lastName: data.userInfo.lastname,
      contactNumber: data.userInfo.tel,
      userStatus: data.userStatus,
      roleCode: data.role,
      projectCode: data.mainProject,
    }

    handleOnSave(request)
  }

  return (
    <>
      {formSchema && (
        <Panel shaded header={formSchema.header} collapsible defaultExpanded>
          <Form>
            {!editObj && (
              <>
                <Row>
                  {vlidateError && (
                    <Col lg={24} md={24} sm={24} xs={24}>
                      <Message
                        showIcon
                        type="error"
                        description={vlidateError}
                        style={{ marginBottom: 10 }}
                      />
                    </Col>
                  )}

                  <Col lg={4} md={4} sm={24} xs={24}>
                    <ControlLabel>
                      {requiredFiled(formSchema.userName.validators, formSchema.userName.label)}
                    </ControlLabel>
                  </Col>
                  <Col lg={8} md={8} sm={24} xs={24}>
                    <Input
                      name={formSchema.userName.name}
                      value={userName || ''}
                      placeholder={formSchema.userName.hint || `ระบุ${formSchema.userName.label}`}
                      // inputRef={register(isValidators(formSchema.userName.validators))}
                      onChange={(value) => {
                        setUsername(value)
                      }}
                    />
                  </Col>

                  <Col lg={3} md={3} sm={24} xs={24} style={{ textAlign: 'left' }}>
                    <Button
                      appearance="primary"
                      block
                      onClick={() => {
                        if (isEmpty(userName)) {
                          setUserInfo('')
                          setVlidateError(
                            isValidators(formSchema.userName.validators)?.required ||
                              `กรุณากรอก ${formSchema.userName.label}`
                          )
                        } else {
                          setVlidateError()
                          onSearch(userName)
                        }
                      }}
                    >
                      <Icon
                        className="fill-color"
                        icon={'search'}
                        style={{ paddingRight: '5px' }}
                      />
                      ค้นหา
                    </Button>
                  </Col>
                  <Col
                    lg={10}
                    md={10}
                    sm={24}
                    xs={24}
                    style={{ marginTop: '5px', padding: '8px' }}
                  ></Col>
                </Row>

                {searchError && (
                  <Row>
                    <Col>
                      <Message showIcon type="warning" description={searchError} closable />
                    </Col>
                  </Row>
                )}
              </>
            )}

            {userInfo && (
              <>
                <Controller
                  key={'userInfo'}
                  name={'userInfo'}
                  control={control}
                  defaultValue={userInfo}
                />
                <div style={{ padding: 10 }}>
                  <b> {!editObj ? 'ผลการค้นหา' : 'ข้อมูลผู้ใช้งาน'}</b>

                  <div style={{ padding: '10px 20px' }}>
                    <Row>
                      <Col lg={4} md={4} sm={4} xs={24}>
                        ชื่อผู้ใช้งาน/อีเมล
                      </Col>
                      <Col lg={20} md={20} sm={20} xs={24}>
                        <p>
                          <b> : </b>
                          {userInfo.email}
                        </p>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg={4} md={4} sm={4} xs={24}>
                        ชื่อ - นามสกุล
                      </Col>
                      <Col lg={20} md={20} sm={20} xs={24}>
                        <p>
                          <b> : </b>
                          {`${userInfo.firstname} ${userInfo.lastname}`}
                        </p>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg={4} md={4} sm={4} xs={24}>
                        ติดต่อ
                      </Col>
                      <Col lg={20} md={20} sm={20} xs={24}>
                        <p>
                          <b> : </b>
                          {userInfo.tel}
                        </p>
                      </Col>
                    </Row>
                  </div>
                </div>

                <hr />
                <Row>
                  <Col xs={24} sm={24} md={24} lg={24}>
                    <ErrorMessage error={errors[formSchema.role.name]} />
                    <ControlLabel>
                      {requiredFiled(formSchema.role.validators, formSchema.role.label)}
                    </ControlLabel>
                  </Col>

                  <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 10 }}>
                    <Controller
                      key={formSchema.role.name}
                      name={formSchema.role.name}
                      control={control}
                      rules={isValidators(formSchema.role.validators)}
                      defaultValue={formSchema.role.value}
                      render={(props) => {
                        return (
                          <CheckboxGroup
                            inline
                            name={formSchema.role.name + 'ck'}
                            value={props.value || []}
                            onChange={(value) => {
                              props.onChange(value)
                            }}
                          >
                            {formSchema.role.options.map((item) => (
                              <Checkbox value={item.value}>{item.label}</Checkbox>
                            ))}
                          </CheckboxGroup>
                        )
                      }}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col xs={24} sm={24} md={24} lg={24}>
                    <ErrorMessage error={errors[formSchema.userStatus.name]} />
                    <ControlLabel>
                      {requiredFiled(formSchema.userStatus.validators, formSchema.userStatus.label)}
                    </ControlLabel>
                  </Col>

                  <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 10 }}>
                    <Controller
                      key={formSchema.userStatus.name}
                      name={formSchema.userStatus.name}
                      control={control}
                      rules={isValidators(formSchema.userStatus.validators)}
                      defaultValue={formSchema.userStatus.value}
                      render={(props) => {
                        return (
                          <RadioGroup
                            inline
                            name={formSchema.userStatus.name + 'radio'}
                            value={props.value || []}
                            onChange={(value) => {
                              props.onChange(value)
                            }}
                          >
                            {formSchema.userStatus.options.map((item) => (
                              <Radio value={item.value}>{item.label}</Radio>
                            ))}
                          </RadioGroup>
                        )
                      }}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col xs={24} sm={24} md={24} lg={24}>
                    <ErrorMessage error={errors[formSchema.mainProject.name]} />
                    <ControlLabel>
                      {requiredFiled(
                        formSchema.mainProject.validators,
                        formSchema.mainProject.label
                      )}
                    </ControlLabel>
                  </Col>
                  <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 15 }}>
                    <Controller
                      key={formSchema.mainProject.name}
                      name={formSchema.mainProject.name}
                      control={control}
                      rules={isValidators(formSchema.mainProject.validators)}
                      defaultValue={formSchema.mainProject.value}
                      // defaultValue={mainProject}
                      render={(props) => {
                        return (
                          <List hover autoScroll style={{ maxHeight: 400 }}>
                            <CheckboxGroup
                              // inline
                              name={formSchema.mainProject.name + 'ck'}
                              value={props.value || []}
                              // value={mainProject || []}
                              onChange={(value) => {
                                props.onChange(value)
                              }}
                            >
                              {formSchema.mainProject.options.map((item, index) => (
                                <List.Item key={item['value'] + index} index={index + 1}>
                                  <FlexboxGrid align="middle">
                                    <FlexboxGrid.Item>
                                      <Checkbox value={item.value}>{item.label}</Checkbox>
                                    </FlexboxGrid.Item>
                                  </FlexboxGrid>
                                </List.Item>
                              ))}
                            </CheckboxGroup>
                          </List>
                        )
                      }}
                    />
                  </Col>
                </Row>
              </>
            )}

            <Row>
              <Col lg={24} md={24} sm={24} xs={24} style={{ marginTop: '5px', padding: '8px' }}>
                <hr />
                <ButtonPanelWidget
                  isDisabled={isLoading || !userInfo}
                  isEdit={isEdit}
                  isError={isError}
                  errorMsg={errorMsg}
                  buttonText={formSchema.buttonText}
                  onSave={handleSubmit(onSubmit)}
                  onCancel={onCancel}
                />
              </Col>
            </Row>
          </Form>
        </Panel>
      )}
    </>
  )
}
